<template>
  <c-card title="개선 사진" class="cardClassDetailForm">
    <template slot="card-detail">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-upload 
          label="개선 전 사진"
          :attachInfo="attachBeforeInfo"
          :editable="editable&&!popupParam.disabled">
        </c-upload>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-upload 
          label="개선 후 사진"
          :attachInfo="attachAfterInfo"
          :editable="editable&&!popupParam.disabled">
        </c-upload>
      </div>
    </template>
  </c-card>
</template>

<script>
export default {
  name: 'fmScenarioImprPicture',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        ram4mAssessScenarioId: '',  // 평가 일련번호
        disabled: false,
      }),
    },
  },
  data() {
    return {
      attachBeforeInfo: {
        isSubmit: '',
        taskClassCd: '4M_SCENARIO_IMPR_BEFORE',
        taskKey: '',
      },
      attachAfterInfo: {
        isSubmit: '',
        taskClassCd: '4M_SCENARIO_IMPR_AFTER',
        taskKey: '',
      },
      editable: false,
    };
  },
  computed: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      this.$set(this.attachBeforeInfo, 'taskKey', this.popupParam.ram4mAssessScenarioId)
      this.$set(this.attachAfterInfo, 'taskKey', this.popupParam.ram4mAssessScenarioId)
      // list setting
    },
  }
};
</script>
